// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dtcoOverviewTable.specialCaseTable tr:nth-child(4) {
  position: sticky;
  top: 6.88rem;
  background-color: var(--background-color-grey);
  z-index: 7;
  padding: 2px;
}
.dtcoOverviewTable.specialCaseTable .bg-selected-baseline {
  background-color: var(--table-select-bg-color);
  border: 0.5px solid var(--border-color);
}
.dtcoOverviewTable.specialCaseTable .bg-selected-option {
  background-color: var(--table-select-option-bg-color);
  border: 0.5px solid var(--border-color);
}
.dtcoOverviewTable {
  font-size: 0.8rem !important;
  overflow-x: auto;
  border: solid 0.2px var(--border-color);
  background-color: var(--background-color-grey);
}
.dtcoOverviewTable tr:first-child {
  background-color: var(--background-color-grey);
  font-weight: bold;
}
.dtcoOverviewTable tr:nth-child(1) {
  position: sticky;
  top: 0px;
  background-color: var(--color-white);
  z-index: 7;
}
.dtcoOverviewTable tr:nth-child(2) {
  position: sticky;
  top: 42px;
  background-color: var(--background-color-grey);
  z-index: 7;
  padding: 2px;
}
.dtcoOverviewTable tr:nth-child(3) {
  position: sticky;
  top: 76px;
  background-color: var(--background-color-grey);
  z-index: 7;
  padding: 2px;
}
.dtcoOverviewTable__header {
  border-bottom: 0.5px solid var(--border-color);
  border-right: 0;
  padding: 5px;
  background-color: var(--background-color-grey);
  width: 200px;
  font-size: 0.69rem;
  font-weight: 500;
  line-height: 1.5rem;
  color: var(--color-maersk-darkblue);
}
.dtcoOverviewTable__header--main {
  border: 0.5px solid var(--border-color);
  padding: 5px;
  background-color: var(--background-color-grey);
  font-size: 0.69rem;
  color: var(--color-maersk-darkblue);
  line-height: 1.5rem;
}
.dtcoOverviewTable__data {
  border: 0.5px solid var(--border-color);
  padding: 9px;
  min-width: 200px;
  background-color: var(--color-white);
}
.dtcoOverviewTable__sticky-column {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 175px;
}
.dtcoOverviewTable .form-control {
  font-size: 0.8rem;
  border-color: var(--table-input-border-color);
}
.dtcoOverviewTable .bg-selected-baseline {
  background-color: var(--table-select-bg-color);
  border-right: 2px solid var(--table-column-border-select-color);
  border-left: 2px solid var(--table-column-border-select-color);
}
.dtcoOverviewTable .bg-selected-option {
  background-color: var(--table-select-option-bg-color);
  border-right: 2px solid var(--table-column-border-option-color);
  border-left: 2px solid var(--table-column-border-option-color);
}
.dtcoOverviewTable .td-border-style {
  border-right: 2px solid var(--table-column-border-select-color);
  border-left: 2px solid var(--table-column-border-select-color);
}
.dtcoOverviewTable .bg-top-baseline {
  border-top: 2px solid var(--table-column-border-select-color);
}
.dtcoOverviewTable .bg-bottom-baseline {
  border-bottom: 2px solid var(--table-column-border-select-color);
}
.dtcoOverviewTable .disabled-text {
  color: var(--color-black);
  cursor: not-allowed;
}
.dtcoOverviewTable .highlight-text {
  color: var(--table-column-border-select-color);
  padding: 5px;
}
.dtcoOverviewTable .dollar-sign,
.dtcoOverviewTable .small-font {
  font-size: smaller;
}
.dtcoOverviewTable .subTable th,
.dtcoOverviewTable .subTable td {
  border: solid 1px var(--border-color);
}

.dropdownDiv {
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 2px;
}
.dropdownDiv .dropDown-left {
  margin-left: 15px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  appearance: "textfield";
}

.service-name-sticky {
  margin-top: -2px;
}`, "",{"version":3,"sources":["webpack://./src/pages/DtcoOverviewPage/DtcoOverviewTable/DtcoOverviewTable.scss"],"names":[],"mappings":"AASQ;EACI,gBAAA;EACA,YAAA;EACA,8CAAA;EACA,UAAA;EACA,YAAA;AARZ;AAUQ;EACI,8CAAA;EACA,uCAAA;AARZ;AAUQ;EACI,qDAAA;EACA,uCAAA;AARZ;AAPA;EAkBI,4BAAA;EACA,gBAAA;EACA,uCAAA;EACA,8CAAA;AARJ;AAUI;EACI,8CAAA;EACA,iBAAA;AARR;AAWI;EACI,gBAAA;EACA,QAAA;EACA,oCAAA;EACA,UAAA;AATR;AAYI;EACI,gBAAA;EACA,SAAA;EACA,8CAAA;EACA,UAAA;EACA,YAAA;AAVR;AAaI;EACI,gBAAA;EACA,SAAA;EACA,8CAAA;EACA,UAAA;EACA,YAAA;AAXR;AAcI;EACI,8CAAA;EACA,eAAA;EACA,YAAA;EACA,8CAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mCAAA;AAZR;AAcQ;EACI,uCAAA;EACA,YAAA;EACA,8CAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;AAZZ;AAgBI;EACI,uCAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;AAdR;AAiBI;EACI,gBAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;AAfR;AAkBI;EACI,iBAAA;EACA,6CAAA;AAhBR;AAmBI;EACI,8CAAA;EAlGJ,+DAAA;EAAA,8DAAA;AAmFJ;AAmBI;EACI,qDAAA;EApGJ,+DAAA;EAAA,8DAAA;AAqFJ;AAoBI;EA5GA,+DAAA;EAAA,8DAAA;AA4FJ;AAqBI;EAjHA,6DAAA;AA+FJ;AAsBI;EArHA,gEAAA;AAkGJ;AAuBI;EACI,yBAAA;EACA,mBAAA;AArBR;AAwBI;EACI,8CAAA;EACA,YAAA;AAtBR;AAyBI;;EAEI,kBAAA;AAvBR;AA4BQ;;EAEI,qCAAA;AA1BZ;;AA+BA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;AA5BJ;AA8BI;EACI,iBAAA;AA5BR;;AAgCA,gCAAA;AACA;;EAEI,wBAAA;EACA,SAAA;AA7BJ;;AAgCA,YAAA;AACA;EAEI,uBAAA;AA7BJ;;AAgCA;EACI,gBAAA;AA7BJ","sourcesContent":["@mixin border-style($direction) {\n    border-#{$direction}: 2px solid var(--table-column-border-select-color);\n}\n@mixin border-styleOption($direction) {\n    border-#{$direction}: 2px solid var(--table-column-border-option-color);\n}\n\n.dtcoOverviewTable {\n    &.specialCaseTable{\n        tr:nth-child(4) {\n            position: sticky;\n            top: 6.88rem;\n            background-color: var(--background-color-grey);\n            z-index: 7;\n            padding: 2px;\n        }\n        .bg-selected-baseline {\n            background-color: var(--table-select-bg-color);\n            border: 0.5px solid var(--border-color);\n        }\n        .bg-selected-option{\n            background-color: var(--table-select-option-bg-color);\n            border: 0.5px solid var(--border-color);\n        }\n    }\n    font-size: 0.8rem !important;\n    overflow-x: auto;\n    border: solid 0.2px var(--border-color);\n    background-color: var(--background-color-grey);\n\n    tr:first-child {\n        background-color: var(--background-color-grey);\n        font-weight: bold;\n    }\n\n    tr:nth-child(1) {\n        position: sticky;\n        top: 0px;\n        background-color: var(--color-white);\n        z-index: 7;\n    }\n\n    tr:nth-child(2) {\n        position: sticky;\n        top: 42px;\n        background-color: var(--background-color-grey);\n        z-index: 7;\n        padding: 2px;\n    }\n\n    tr:nth-child(3) {\n        position: sticky;\n        top: 76px;\n        background-color: var(--background-color-grey);\n        z-index: 7;\n        padding: 2px;\n    }\n\n    &__header {\n        border-bottom: 0.5px solid var(--border-color);\n        border-right: 0;\n        padding: 5px;\n        background-color: var(--background-color-grey);\n        width: 200px;\n        font-size: 0.69rem;\n        font-weight: 500;\n        line-height: 1.5rem;\n        color: var(--color-maersk-darkblue);\n\n        &--main {\n            border: 0.5px solid var(--border-color);\n            padding: 5px;\n            background-color: var(--background-color-grey);\n            font-size: 0.69rem;\n            color: var(--color-maersk-darkblue);\n            line-height: 1.5rem;\n        }\n    }\n\n    &__data {\n        border: 0.5px solid var(--border-color);\n        padding: 9px;\n        min-width: 200px;\n        background-color: var(--color-white);\n    }\n\n    &__sticky-column {\n        position: sticky;\n        left: 0;\n        z-index: 1;\n        min-width: 175px;\n    }\n\n    .form-control {\n        font-size: 0.8rem;\n        border-color: var(--table-input-border-color);\n    }\n\n    .bg-selected-baseline {\n        background-color: var(--table-select-bg-color);\n        @include border-style(right);\n        @include border-style(left);\n    }\n    .bg-selected-option{\n        background-color: var(--table-select-option-bg-color);\n        @include border-styleOption(right);\n        @include border-styleOption(left);\n    }\n\n    .td-border-style {\n        @include border-style(right);\n        @include border-style(left);\n    }\n\n    .bg-top-baseline {\n        @include border-style(top);\n    }\n\n    .bg-bottom-baseline {\n        @include border-style(bottom);\n    }\n\n    .disabled-text {\n        color: var(--color-black);\n        cursor: not-allowed;\n    }\n\n    .highlight-text {\n        color: var(--table-column-border-select-color);\n        padding: 5px;\n    }\n\n    .dollar-sign,\n    .small-font {\n        font-size: smaller;\n    }\n\n    .subTable {\n\n        th,\n        td {\n            border: solid 1px var(--border-color);\n        }\n    }\n}\n\n.dropdownDiv {\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    padding: 2px;\n\n    .dropDown-left {\n        margin-left: 15px;\n    }\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n    -moz-appearance: textfield;\n    appearance: \"textfield\";\n}\n\n.service-name-sticky {\n    margin-top: -2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
